
import * as Yup from "yup";


export const paymentGatewaySchema= Yup.object().shape({
  selectedGateway: Yup.string().required("Required"),
  payment_gateway_name: Yup.string().required("Required"),
  stripe: Yup.object().when("selectedGateway", {
    is: "Stripe",
    then: Yup.object().shape({
      stripe_key: Yup.string().required("Required"),
      publicKey: Yup.string().required("Required"),
    }),
  }),
  authorize: Yup.object().when("selectedGateway", {
    is: "Authorize",
    then: Yup.object().shape({
      api_login_id: Yup.string().required("Required"),
      transaction_key: Yup.string().required("Required"),
    }), 
  }),
  banquest: Yup.object().when("selectedGateway", {
    is: "BanQuest",
    then: Yup.object().shape({
      source_key: Yup.string().required("Required"),
      pin: Yup.string().required("Required"),
    }),
  }),
  tranzila: Yup.object().when("selectedGateway", {
    is: "Tranzila",
    then: Yup.object().shape({
      terminal_name: Yup.string().required("Required"),
      app_key: Yup.string().required("Required"),
      secret_key: Yup.string().required("Required"),
    }),
  }),
});
